import { EditFormMode, RydeUiUnit, type TIncidentStatus } from "@ryde/shared";

export type TRideIncidentStatusFilter = "all" | TIncidentStatus;

export const incidentUnboundCrudKey: [RydeUiUnit, EditFormMode] = [
  "incident",
  EditFormMode.UnboundDrawer,
];

export interface IIncidentTypeOption {
  id: number;
  name: string;
}

export interface IPickedLatLng {
  lat: number;
  lng: number;
}
